import { render, staticRenderFns } from "./saveAdvert.vue?vue&type=template&id=29d617e0&scoped=true&"
import script from "./saveAdvert.vue?vue&type=script&lang=js&"
export * from "./saveAdvert.vue?vue&type=script&lang=js&"
import style0 from "./saveAdvert.vue?vue&type=style&index=0&id=29d617e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d617e0",
  null
  
)

export default component.exports